import Footer from '@/components/Footer'

const $ = require('jquery')

const { BREAKPOINT } = require('./api')

const initFooter = footer => {
  const component = new Footer(footer)
  return component.init()
}

const initFooterSlider = footer => {
  $(footer).find('.rank-slider').slick({
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    draggable: false,
    responsive: [ {
      breakpoint: BREAKPOINT.DESKTOP,
      settings: {
        slidesToShow: 1,
      },
    } ],
  })
}

export function init () {
  document.querySelectorAll('footer').forEach(footer => {
    initFooter(footer)
    initFooterSlider(footer)
  })
}



// WEBPACK FOOTER //
// ./src/modules/footer.js